
import * as XLSX from 'xlsx';

/**
 * Creates a sample Excel file with multi-language product data
 */
export const createTestExcelFile = (): Blob => {
  // Create a new workbook
  const wb = XLSX.utils.book_new();
  
  // Sample data with the correct columns, including Amharic examples
  const data = [
    { product_name: 'Apple', measuring_unit: 'kg', category_name: 'Fruits', description: 'Red fruit' },
    { product_name: 'ሙዝ', measuring_unit: 'kg', category_name: 'ፍራፍሬዎች', description: 'Yellow fruit' },
    { product_name: 'ቲማቲም', measuring_unit: 'kg', category_name: 'አትክልቶች', description: 'Red vegetable' },
    { product_name: 'Carrot', measuring_unit: 'kg', category_name: 'Vegetables', description: 'Orange vegetable' },
  ];
  
  // Convert data to a worksheet with UTF-8 encoding
  const ws = XLSX.utils.json_to_sheet(data);
  
  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Products');
  
  // Generate Excel file as binary string
  const excelBinary = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
  
  // Convert binary string to ArrayBuffer
  const buf = new ArrayBuffer(excelBinary.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < excelBinary.length; i++) {
    view[i] = excelBinary.charCodeAt(i) & 0xFF;
  }
  
  // Return as Blob
  return new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
};
